import { render, staticRenderFns } from "./PracticeVedAdmin.vue?vue&type=template&id=40e138cd&scoped=true&"
import script from "./PracticeVedAdmin.vue?vue&type=script&lang=js&"
export * from "./PracticeVedAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e138cd",
  null
  
)

export default component.exports